// Libraries
import { VictoryScatter } from 'victory';
// Types
import { VictoryPointScatters } from './VictoryPointScatters.types';
// Utils
import { pointScatterVariations } from '@theme/victory';

/**
 * Renders VictoryScatter components based on the provided VictoryPointScatters data.
 *
 * @param {VictoryPointScatters} victoryPointScatters - The data representing multiple point scatters to be rendered on the chart.
 * @returns {ReactElement[]} - An array of React elements representing the rendered VictoryScatter components.
 *
 * @example
 * const data = [
 *   { x: 1, y: 10 },
 *   { x: 2, y: 15 },
 *   { x: 3, y: 12 },
 *   //...
 * ];
 *
 * const pointScatters = [
 *   { id: 'scatter1', data: data, styleKey: 'A', title: 'Scatter 1' },
 *   { id: 'scatter2', data: data, styleKey: 'B', title: 'Scatter 2' },
 *   //...
 * ];
 *
 * const renderedPointScatters = renderVictoryPointScatters(pointScatters);
 * // Returns an array of React elements representing the rendered VictoryScatter components.
 * Important Note: This implementation relies on the Victory library, which does not
 * support creating this
 * component as a separate module due to potential injection vulnerabilities. Please avoid
 * using this
 * function where possible.
 *
 * For more information, refer to the documentation:
 * https://formidable.com/open-source/victory/docs
 */
export const renderVictoryPointScatters = (victoryPointScatters: VictoryPointScatters) => {
  return victoryPointScatters.map(({ id, data, styleKey, title }) => {
    const dataSet = data.map((point) => ({ ...point, title }));

    return <VictoryScatter key={id} data={dataSet} style={pointScatterVariations[styleKey]} />;
  });
};
